export const styles = {
  container: {
    textAlign: 'left',
    padding: '3%',
    marginBottom: '5%',
  },
};
